import { rankWith, schemaMatches } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { useTranslation } from "react-i18next";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import ImageIcon from "@mui/icons-material/Image";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import SFTextField from "../../textField";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const AvatarStyled = styled(Avatar, { shouldForwardProp: false })(
  ({ theme, color }) => ({
    backgroundColor: theme.palette.grey50.main,
    border: `1px ${theme.palette.grey250.main} solid`,
    borderRadius: "4px",
    color: theme.palette.grey450.main,
    marginRight: "8px",
  })
);

const TextWithIconRenderer = ({
  data,
  handleChange,
  path,
  uischema,
  required,
  enabled,
  errors,
}) => {
  const { t } = useTranslation();
  const { i18nKey, label, options } = uischema;

  const onChange = (e) => {
    const text = e.target.value;
    if (text.trim() === "") {
      return handleChange(path, undefined);
    }
    handleChange(path, text);
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {!options.iconInsideText && (
        <AvatarStyled variant="square">
          {options?.icon == "ImageIcon" && <ImageIcon />}
          {options?.icon == "TouchAppIcon" && <TouchAppIcon />}
          {options?.icon == "FileCopyIcon" && <FileCopyIcon />}
          {options?.icon == "ClosedCaptionIcon" && <ClosedCaptionIcon />}
          {options?.icon == "OndemandVideoIcon" && <OndemandVideoIcon />}
        </AvatarStyled>
      )}
      <SFTextField
        label={i18nKey ? t(i18nKey) : label}
        value={data ? data : ""}
        variant="filled"
        disabled={options?.readonly || !enabled}
        readOnly={options?.readonly}
        required={required}
        onChange={onChange}
        errors={errors}
        maxLength={options?.maxLength}
        {...(options?.iconInsideText && { textIcon: options.icon })}
        isCopilotField={options?.isCopilotField}
      />
    </Box>
  );
};

export const TextWithIconTester = rankWith(
  104,
  schemaMatches((schema) => schema.icon)
);

export default withJsonFormsControlProps(TextWithIconRenderer);
